import { render, staticRenderFns } from "./Banners.component.vue?vue&type=template&id=c43f0c82&scoped=true"
import script from "./Banners.component.vue?vue&type=script&lang=js"
export * from "./Banners.component.vue?vue&type=script&lang=js"
import style0 from "./Banners.component.vue?vue&type=style&index=0&id=c43f0c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43f0c82",
  null
  
)

export default component.exports